import script from "./StudioComboSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudioComboSelect.vue?vue&type=script&setup=true&lang=ts"

import "./StudioComboSelect.vue?vue&type=style&index=0&id=7c3f2bb0&lang=scss"

const __exports__ = script;

export default __exports__